import { KameleoonFlagKey, useFeatureFlagValue } from '@lingoda/kameleoon';

export const useIsOnboardingM2PledgeEnabled = () => {
    const flag = useFeatureFlagValue(KameleoonFlagKey.onboardingM2Pledge);

    return {
        isLoading: flag.isLoading,
        isPledgeEnabled: !flag.isLoading && flag.isVariant,
    };
};
